exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-33d1540e]{padding:20px}.item[data-v-33d1540e]{margin:15px 0}.item label[data-v-33d1540e]{display:inline-block;width:auto;padding:8px;background:#eee}.item span[data-v-33d1540e]{display:block;padding:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33d1540e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Incident.vue
// module id = 161
// module chunks = 0